import React from 'react';
import {useField} from 'formik';
import {Input} from '../../../../../../../form/form.jsx';

const Ambassadors = () => {
  const [field, meta, helpers] = useField('ambassadors');

  const {error, touched} = meta;
  const {setValue} = helpers;

  const isValid = !(error && touched);

  return (
    <Input
      {...field}
      placeholder="ФИО представителя"
      isValid={isValid}
      onChange={setValue}
    />
  );
};

export default Ambassadors;
